import {
    GET_RESOURCE_ACCESS_SUCCESS,
    GET_RESOURCE_BY_ID_SUCCESS,
    GET_RESOURCE_DOCUMENT_SUCCESS,
    GET_RESOURCE_SUCCESS,
} from './resource.types';

const initialState = {
    resourceList: [],
    resourceById: null,
    resourceDocuments: [],
    resourceAccessList: [],
};

export const resourceReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Resource */
        case GET_RESOURCE_SUCCESS:
            return {
                ...state,
                resourceList: action.payload,
            };

        case GET_RESOURCE_BY_ID_SUCCESS:
            return {
                ...state,
                resourceById: action.payload,
            };
        /** End */

        /** Resource Documents*/
        case GET_RESOURCE_DOCUMENT_SUCCESS:
            return {
                ...state,
                resourceDocuments: action.payload,
            };

        /** End */

        /** Resource Access */
        case GET_RESOURCE_ACCESS_SUCCESS:
            return {
                ...state,
                resourceAccessList: action.payload,
            };

        /** End */

        default:
            return state;
    }
};
